'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getSessionInfo = require('./http-721ad2e6.js');
var http = require('./http-bb56b50d.js');
var getHost = require('./getHost-bdfdb786.js');
var constants = require('./constants.js');
var EventEmitter = require('events');
require('axios');
require('md5');
require('@mkt-common/shopee-common');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);

// parse json without error
function jsonParse(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return {};
  }
}
var ReasonType;
(function (ReasonType) {
  ReasonType["agent"] = "agent";
  ReasonType["client"] = "client";
  ReasonType["timeout"] = "chatbot_session_close_timeout";
})(ReasonType || (ReasonType = {}));
var MsgHttpType;
(function (MsgHttpType) {
  MsgHttpType["Message"] = "Message";
  MsgHttpType["StartSession"] = "StartSession";
  MsgHttpType["CloseSession"] = "CloseSession";
})(MsgHttpType || (MsgHttpType = {}));
var MsgStatus;
(function (MsgStatus) {
  MsgStatus[MsgStatus["Sending"] = 0] = "Sending";
  MsgStatus[MsgStatus["Fail"] = 1] = "Fail";
  MsgStatus[MsgStatus["Success"] = 2] = "Success";
})(MsgStatus || (MsgStatus = {}));
var ErrorCode;
(function (ErrorCode) {
  ErrorCode[ErrorCode["SessionExpires"] = 1026] = "SessionExpires";
})(ErrorCode || (ErrorCode = {}));
var wsPathInjector = undefined;
function configWsPathInjector(paramWsPathInjector) {
  if (typeof paramWsPathInjector === 'function') {
    wsPathInjector = paramWsPathInjector;
    return;
  }
  console.warn("Invalid type of wsPathInjector: ", typeof paramWsPathInjector);
}
function getWsPathInjector() {
  return wsPathInjector;
}
var handlerForStorageKeyMap = {
  beforeInit: getSessionInfo.chatBeforeInitMessageKey,
  init: getSessionInfo.chatInitMessageKey,
  sendMessageComplete: getSessionInfo.chatSendMessageCompleteKey,
  sendMessage: getSessionInfo.chatSendMessageKey,
  message: getSessionInfo.chatReceiveMessageKey,
  error: getSessionInfo.chatErrorKey,
  close: getSessionInfo.chatCloseKey,
  restore: getSessionInfo.chatRestoreKey,
  rating: getSessionInfo.ratingChatKey,
  updateReadedMessage: getSessionInfo.readedMessageCountKey,
  config: getSessionInfo.chatConfigChangeKey
};
var WorkerProxyConnection = /** @class */function (_super) {
  getSessionInfo.__extends(WorkerProxyConnection, _super);
  function WorkerProxyConnection(handlers) {
    var _this = _super.call(this) || this;
    _this.addHandlers(handlers);
    return _this;
  }
  WorkerProxyConnection.prototype.addHandlers = function (handlers) {
    getSessionInfo.addMessageListener(getSessionInfo.chatRestoreKey, function (data) {
      if (data != null && !getSessionInfo.agentChatScheduler.chatting) {
        restoreChat(handlers, data);
      }
    });
    Object.keys(handlers).forEach(function (value) {
      var key = value;
      getSessionInfo.addMessageListener(handlerForStorageKeyMap[key], function (data) {
        var _a, _b;
        if (data == null || typeof data === 'object' && data.onlyForMaster) {
          return;
        }
        getSessionInfo.devLog('worker receiver message', key, data);
        switch (key) {
          case 'init':
            getSessionInfo.agentChatScheduler.chatting = true;
            break;
          case 'close':
          case 'error':
            getSessionInfo.agentChatScheduler.chatting = false;
            break;
          case 'sendMessageComplete':
            var messages = (_a = getSessionInfo.getStorage(getSessionInfo.chatUnSendMessageKey)) !== null && _a !== void 0 ? _a : [];
            var index = messages.findIndex(function (v) {
              var _a, _b;
              return v.msg_id === ((_b = (_a = data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.msg_id);
            });
            if (index !== -1) {
              messages.splice(index, 1);
              getSessionInfo.setStorage(getSessionInfo.chatUnSendMessageKey, messages);
            }
            break;
        }
        changeAgentChatStatus(key, data);
        return (_b = handlers[key]) === null || _b === void 0 ? void 0 : _b.call(handlers, data);
      });
    });
  };
  WorkerProxyConnection.prototype.emitMessage = function (data) {
    setSendMessageStorage(data);
  };
  WorkerProxyConnection.prototype.emitMessageComplete = function (data) {
    setSendMessageCompleteStorage(data);
  };
  WorkerProxyConnection.prototype.emitReceiveMessage = function (data) {
    setReceiveMessageStorage(data);
  };
  WorkerProxyConnection.prototype.sendMessage = function (bizContent) {
    var _a, _b;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var messages, extraInfo;
      return getSessionInfo.__generator(this, function (_c) {
        messages = (_a = getSessionInfo.getStorage(getSessionInfo.chatUnSendMessageKey)) !== null && _a !== void 0 ? _a : [];
        messages === null || messages === void 0 ? void 0 : messages.push(bizContent);
        getSessionInfo.setStorage(getSessionInfo.chatUnSendMessageKey, messages);
        extraInfo = (_b = getSessionInfo.getStorage(getSessionInfo.chatSendMessageKey)) !== null && _b !== void 0 ? _b : {};
        setSendMessageStorage(getSessionInfo.__assign(getSessionInfo.__assign({}, bizContent), {
          extraInfo: extraInfo,
          onlyForMaster: true
        }));
        return [2 /*return*/];
      });
    });
  };

  WorkerProxyConnection.prototype.close = function (data) {
    if (data === void 0) {
      data = {
        msg: 'MANUAL_CLOSE'
      };
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        setMessageStorage(getSessionInfo.chatCloseKey, getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
          onlyForMaster: true
        }));
        return [2 /*return*/];
      });
    });
  };

  WorkerProxyConnection.prototype.stop = function () {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        setMessageStorage(getSessionInfo.chatStopKey, {});
        return [2 /*return*/];
      });
    });
  };

  return WorkerProxyConnection;
}(EventEmitter__default['default']);
function initChat(config) {
  getSessionInfo.reportDebugLog('init worker tab chat');
  if (canEmitAndRun(getSessionInfo.chatRestoreKey, function (data) {
    return restoreChat(config.connectionHandlers, data);
  })) {
    canEmitAndRun(getSessionInfo.chatConfigChangeKey, config.connectionHandlers.config);
    doUpgradeIfMasterJustGone();
    return;
  }
  emitMessageAndChangeStatus();
  canEmitAndRun(getSessionInfo.chatBeforeInitMessageKey, function (data) {
    return config.connectionHandlers.beforeInit(getSessionInfo.agentChatScheduler.chattingStatus === 'chatting' ? {
      first: true
    } : getSessionInfo.__assign({
      first: true
    }, data));
  });
  canEmitAndRun(getSessionInfo.chatInitMessageKey, config.connectionHandlers.init);
  canEmitAndRun(getSessionInfo.chatReceiveMessageKey, function (data) {
    var _a;
    return config.connectionHandlers.message(getSessionInfo.__assign(getSessionInfo.__assign({}, (_a = data) !== null && _a !== void 0 ? _a : {}), {
      first: true
    }));
  });
  canEmitAndRun(getSessionInfo.chatConfigChangeKey, config.connectionHandlers.config);
  var data = getSessionInfo.getStorage(getSessionInfo.readedMessageCountKey);
  if (data != null) {
    config.connectionHandlers.updateReadedMessage(getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
      first: true
    }));
  }
  doUpgradeIfMasterJustGone();
}
function emitMessageAndChangeStatus() {
  var _a = getSessionInfo.canEmit(getSessionInfo.chatReceiveMessageKey),
    can = _a.can,
    data = _a.data;
  if (can) {
    if ((data === null || data === void 0 ? void 0 : data.msg_type) === 'QUEUING') {
      getSessionInfo.agentChatScheduler.chattingStatus = 'queue';
    } else {
      getSessionInfo.agentChatScheduler.chattingStatus = 'chatting';
    }
  }
  getSessionInfo.agentChatScheduler.chatting = true;
  return {
    can: can,
    data: data
  };
}
function restoreChat(handlers, data) {
  var _a;
  getSessionInfo.reportDebugLog('restore worker tab chat');
  handlers.beforeInit({
    first: true
  });
  handlers.init(data);
  var _b = emitMessageAndChangeStatus(),
    can = _b.can,
    messageData = _b.data;
  if (can) {
    handlers.message(getSessionInfo.__assign(getSessionInfo.__assign({}, (_a = messageData) !== null && _a !== void 0 ? _a : {}), {
      first: true
    }));
  } else {
    handlers.message(getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
      first: true
    }));
  }
  var readedData = getSessionInfo.getStorage(getSessionInfo.readedMessageCountKey);
  if (readedData != null) {
    handlers.updateReadedMessage(getSessionInfo.__assign(getSessionInfo.__assign({}, readedData), {
      first: true
    }));
  }
  if ((messageData === null || messageData === void 0 ? void 0 : messageData.msg_type) !== 'QUEUING') {
    getSessionInfo.agentChatScheduler.chattingStatus = 'chatting';
  }
  doUpgradeIfMasterJustGone();
}
function doUpgradeIfMasterJustGone() {
  var lastHeartbeat = getSessionInfo.getStorage(getSessionInfo.masterHeartbeatKey);
  setTimeout(function () {
    if (getSessionInfo.getStorage(getSessionInfo.masterHeartbeatKey) === lastHeartbeat) {
      getSessionInfo.devLog('master刚刚挂掉了，开始重启...');
      getSessionInfo.reportDebugLog('master刚刚挂掉了，开始重启...');
      getSessionInfo.agentChatScheduler.changeRoleToMaster();
    }
  }, 2 * getSessionInfo.heartbeatInterval);
}
function canEmitAndRun(key, emit) {
  var masterId = getSessionInfo.getStorage(getSessionInfo.masterIdKey);
  var data = getSessionInfo.getStorage(key);
  var can = (data === null || data === void 0 ? void 0 : data.masterId) === masterId;
  can && emit(data);
  return can;
}
function setReceiveMessageStorage(data) {
  setMessageStorage(getSessionInfo.chatReceiveMessageKey, data);
}
function setSendMessageStorage(data) {
  setMessageStorage(getSessionInfo.chatSendMessageKey, data);
}
function setSendMessageCompleteStorage(data) {
  setMessageStorage(getSessionInfo.chatSendMessageCompleteKey, data);
}
function setRatingStorage(data) {
  setMessageStorage(getSessionInfo.ratingChatKey, data);
}
function setReadedMessageStorage(data) {
  setMessageStorage(getSessionInfo.readedMessageCountKey, data);
}
function setMessageStorage(key, data) {
  function generateData(data) {
    return getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
      currentId: getSessionInfo.getSessionStorage(getSessionInfo.currentIdKey),
      masterId: getSessionInfo.getStorage(getSessionInfo.masterIdKey),
      timestamp: Date.now()
    });
  }
  getSessionInfo.setStorage(key, generateData(data));
}
function changeAgentChatStatus(key, data) {
  if (key === 'init') {
    getSessionInfo.agentChatScheduler.chattingStatus = 'queue';
  } else if (key === 'message') {
    if (data.msg_type === 'QUEUING') {
      getSessionInfo.agentChatScheduler.chattingStatus = 'queue';
    } else {
      getSessionInfo.agentChatScheduler.chattingStatus = 'chatting';
    }
  } else if (key === 'close' || key === 'error') {
    getSessionInfo.agentChatScheduler.chattingStatus = 'queue';
  }
}
var ChatStatus;
(function (ChatStatus) {
  ChatStatus[ChatStatus["Init"] = 0] = "Init";
  ChatStatus[ChatStatus["Queuing"] = 1] = "Queuing";
  ChatStatus[ChatStatus["Joined"] = 2] = "Joined";
  ChatStatus[ChatStatus["Closed"] = 3] = "Closed";
})(ChatStatus || (ChatStatus = {}));
var MessageBroadcastEventEmitter = /** @class */function (_super) {
  getSessionInfo.__extends(MessageBroadcastEventEmitter, _super);
  function MessageBroadcastEventEmitter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.chat_status = ChatStatus.Init;
    return _this;
  }
  MessageBroadcastEventEmitter.prototype.emitMessage = function (data) {
    if (canEmit()) {
      setSendMessageStorage(data);
    }
  };
  MessageBroadcastEventEmitter.prototype.emitMessageComplete = function (data) {
    if (canEmit()) {
      setSendMessageCompleteStorage(data);
    }
  };
  MessageBroadcastEventEmitter.prototype.emitReceiveMessage = function (data) {
    if (canEmit()) {
      setReceiveMessageStorage(data);
    }
  };
  MessageBroadcastEventEmitter.prototype.emit = function (event) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var result = _super.prototype.emit.apply(this, getSessionInfo.__spreadArray([event], args));
    if (!canEmit()) {
      return result;
    }
    var data = args[0];
    var storageKey = handlerForStorageKeyMap[event];
    if (storageKey != null) {
      getSessionInfo.devLog("emit " + event, data);
      setMessageStorage(storageKey, data);
      switch (event) {
        case 'beforeInit':
          setMessageStorage(getSessionInfo.initConnectionInfoKey, data);
          break;
        case 'init':
          this.chat_status = ChatStatus.Init;
          getSessionInfo.agentChatScheduler.chatting = true;
          setMessageStorage(getSessionInfo.connectionInfoKey, data);
          break;
        case 'message':
          if (data.msg_type === 'QUEUING') {
            this.chat_status = ChatStatus.Queuing;
          }
          if (data.msg_type === 'CS_JOINED') {
            this.chat_status = ChatStatus.Joined;
          }
          break;
        case 'close':
        case 'error':
          this.chat_status = ChatStatus.Closed;
          getSessionInfo.agentChatScheduler.close();
          break;
      }
    }
    changeAgentChatStatus(event, data);
    return result;
  };
  return MessageBroadcastEventEmitter;
}(EventEmitter.EventEmitter);
function canEmit() {
  return getSessionInfo.agentChatScheduler.inited && getSessionInfo.agentChatScheduler.isMaster;
}
var Heartbeat = /** @class */function (_super) {
  getSessionInfo.__extends(Heartbeat, _super);
  function Heartbeat(heartbeatConfig) {
    var _this = _super.call(this) || this;
    _this.heartbeatTimer = null;
    _this.closeConnectionTimer = null;
    var heartbeatTimeout = heartbeatConfig.heartbeatTimeout,
      closeConnectionTimeout = heartbeatConfig.closeConnectionTimeout;
    _this.heartbeatTimeout = heartbeatTimeout;
    _this.closeConnectionTimeout = closeConnectionTimeout;
    return _this;
  }
  Heartbeat.prototype.reset = function () {
    if (this.heartbeatTimer) {
      clearTimeout(this.heartbeatTimer);
    }
    if (this.closeConnectionTimer) {
      clearTimeout(this.closeConnectionTimer);
    }
  };
  Heartbeat.prototype.start = function () {
    var _this = this;
    this.reset();
    this.heartbeatTimer = window.setTimeout(function () {
      _this.emit('sendPing');
      _this.closeConnectionTimer = window.setTimeout(function () {
        _this.emit('closeWs');
      }, _this.closeConnectionTimeout);
    }, this.heartbeatTimeout);
  };
  return Heartbeat;
}(EventEmitter.EventEmitter);
var DEFAULT_HEARTBEAT_TIMEOUT = 10000; // 心跳延时
var DEFAULT_CLOSE_CONNECTION_TIMEOUT = 60000; // 心跳超时关闭连接延时
var DEFAULT_MAX_RETRY_TIME = 27; // 最大重试次数
var DEFAULT_RECONNECT_TIMEOUT = 2000; // 重连延时
var RECONNECT_TIMEOUT_INCREASE_UNIT = 1000; // 重连延时逐渐增加单位
var ReconnectWebsocket = /** @class */function (_super) {
  getSessionInfo.__extends(ReconnectWebsocket, _super);
  function ReconnectWebsocket(config) {
    var _this = _super.call(this) || this;
    _this.isReconnecting = false;
    _this.reconnectTimer = null;
    _this.currentRetryTime = 0;
    _this.ws = null;
    _this.heartbeat = null;
    var _a = config.heartbeatTimeout,
      heartbeatTimeout = _a === void 0 ? DEFAULT_HEARTBEAT_TIMEOUT : _a,
      _b = config.reconnectTimeout,
      reconnectTimeout = _b === void 0 ? DEFAULT_RECONNECT_TIMEOUT : _b,
      _c = config.closeConnectionTimeout,
      closeConnectionTimeout = _c === void 0 ? DEFAULT_CLOSE_CONNECTION_TIMEOUT : _c,
      _d = config.maxRetryTime,
      maxRetryTime = _d === void 0 ? DEFAULT_MAX_RETRY_TIME : _d;
    _this.reconnectTimeout = reconnectTimeout;
    _this.maxRetryTime = maxRetryTime;
    _this.errorHandler = _this.errorHandler.bind(_this);
    _this.closeHandler = _this.closeHandler.bind(_this);
    _this.openHandler = _this.openHandler.bind(_this);
    _this.messageHandler = _this.messageHandler.bind(_this);
    _this.onlineHandler = _this.onlineHandler.bind(_this);
    _this.ping = _this.ping.bind(_this);
    _this.closeWs = _this.closeWs.bind(_this);
    _this.initHeartbeat({
      heartbeatTimeout: heartbeatTimeout,
      closeConnectionTimeout: closeConnectionTimeout
    });
    return _this;
  }
  ReconnectWebsocket.prototype.initHeartbeat = function (config) {
    this.heartbeat = new Heartbeat(config);
    this.heartbeat.on('sendPing', this.ping);
    this.heartbeat.on('closeWs', this.closeWs);
  };
  ReconnectWebsocket.prototype.setLogger = function (logger) {
    this.logger = logger;
  };
  ReconnectWebsocket.prototype.resetRetryConfig = function () {
    this.currentRetryTime = 0;
    this.reconnectTimeout = DEFAULT_RECONNECT_TIMEOUT;
  };
  ReconnectWebsocket.prototype.setWs = function (ws) {
    this.removeAllEvents();
    this.removeAllListeners();
    this.ws = ws;
    this.initAllEvents();
    if (this.currentRetryTime === 0) {
      // socket初次连接数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'channel_chat_websocket_first_init_total'
        }
      });
    }
    // socket连接数（包括重连）
    getSessionInfo.batchReportGrafana({
      type: 'count',
      value: {
        label: 'websocket_init_total'
      }
    });
  };
  ReconnectWebsocket.prototype.initAllEvents = function () {
    this.initWsEvent();
    this.initNetworkEvent();
  };
  ReconnectWebsocket.prototype.removeAllEvents = function () {
    var _a;
    this.removeWsEvent();
    this.removeNetworkEvent();
    (_a = this.heartbeat) === null || _a === void 0 ? void 0 : _a.reset();
    this.cancelReconnect();
  };
  ReconnectWebsocket.prototype.initWsEvent = function () {
    var _a, _b, _c, _d;
    (_a = this.ws) === null || _a === void 0 ? void 0 : _a.addEventListener('error', this.errorHandler);
    (_b = this.ws) === null || _b === void 0 ? void 0 : _b.addEventListener('close', this.closeHandler);
    (_c = this.ws) === null || _c === void 0 ? void 0 : _c.addEventListener('message', this.messageHandler);
    (_d = this.ws) === null || _d === void 0 ? void 0 : _d.addEventListener('open', this.openHandler);
  };
  ReconnectWebsocket.prototype.initNetworkEvent = function () {
    window.addEventListener('online', this.onlineHandler);
  };
  ReconnectWebsocket.prototype.removeWsEvent = function () {
    var _a, _b, _c, _d;
    (_a = this.ws) === null || _a === void 0 ? void 0 : _a.removeEventListener('error', this.errorHandler);
    (_b = this.ws) === null || _b === void 0 ? void 0 : _b.removeEventListener('close', this.closeHandler);
    (_c = this.ws) === null || _c === void 0 ? void 0 : _c.removeEventListener('message', this.messageHandler);
    (_d = this.ws) === null || _d === void 0 ? void 0 : _d.removeEventListener('open', this.openHandler);
  };
  ReconnectWebsocket.prototype.removeNetworkEvent = function () {
    window.removeEventListener('online', this.onlineHandler);
  };
  ReconnectWebsocket.prototype.errorHandler = function () {
    var _a;
    if (this.currentRetryTime === 0) {
      // socket初次链接失败数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'channel_chat_websocket_first_init_fail_total'
        }
      });
    }
    this.reconnect();
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error('websocket error');
    getSessionInfo.batchReportGrafana({
      type: 'count',
      value: {
        label: 'websocket_error_total'
      }
    });
  };
  ReconnectWebsocket.prototype.closeHandler = function (e) {
    var _a;
    this.reconnect();
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('websocket closed', {
      code: e.code,
      reason: e.reason,
      wasClean: e.wasClean
    });
  };
  ReconnectWebsocket.prototype.openHandler = function () {
    var _a;
    (_a = this.heartbeat) === null || _a === void 0 ? void 0 : _a.start();
    this.cancelReconnect();
    this.currentRetryTime = 0;
    this.reconnectTimeout = DEFAULT_RECONNECT_TIMEOUT;
    getSessionInfo.batchReportGrafana({
      type: 'count',
      value: {
        label: 'websocket_open_total'
      }
    });
  };
  ReconnectWebsocket.prototype.messageHandler = function (e) {
    var _a;
    (_a = this.heartbeat) === null || _a === void 0 ? void 0 : _a.start();
  };
  ReconnectWebsocket.prototype.checkIfCanReconnect = function () {
    var _a;
    if (this.isReconnecting) {
      return false;
    }
    if (this.currentRetryTime >= this.maxRetryTime) {
      // this.emit(
      //   'error',
      //   new Error('Reached the maximum number of retry times')
      // );
      (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error('Reconnect reached the maximum number of retry times');
      return false;
    }
    return true;
  };
  ReconnectWebsocket.prototype.reconnect = function () {
    if (!this.checkIfCanReconnect()) {
      return;
    }
    // 只执行立即重连一次，之后继续恢复延时重连
    if (this.currentRetryTime >= 1) {
      this.reconnectWithDelay();
      return;
    }
    this.clearTimeout();
    this.isReconnecting = true;
    this.emit('reconnect', {
      count: this.currentRetryTime + 1,
      timeout: this.reconnectTimeout
    });
    this.isReconnecting = false;
    this.currentRetryTime += 1;
  };
  ReconnectWebsocket.prototype.reconnectWithDelay = function () {
    var _this = this;
    if (!this.checkIfCanReconnect()) {
      return;
    }
    this.isReconnecting = true;
    this.reconnectTimer = window.setTimeout(function () {
      return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
        return getSessionInfo.__generator(this, function (_a) {
          this.clearTimeout();
          this.currentRetryTime += 1;
          this.reconnectTimeout += RECONNECT_TIMEOUT_INCREASE_UNIT;
          this.emit('reconnect', {
            count: this.currentRetryTime,
            timeout: this.reconnectTimeout
          });
          this.isReconnecting = false;
          return [2 /*return*/];
        });
      });
    }, this.reconnectTimeout);
  };
  ReconnectWebsocket.prototype.ping = function () {
    this.emit('ping');
  };
  ReconnectWebsocket.prototype.closeWs = function () {
    var _a;
    (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
  };
  ReconnectWebsocket.prototype.onlineHandler = function () {
    var _a;
    this.increaseReconnectTimeout();
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('network online');
  };
  ReconnectWebsocket.prototype.increaseReconnectTimeout = function () {
    this.reconnectTimeout = DEFAULT_RECONNECT_TIMEOUT;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.isReconnecting = false;
      this.reconnectWithDelay();
    }
  };
  ReconnectWebsocket.prototype.clearTimeout = function () {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  };
  ReconnectWebsocket.prototype.cancelReconnect = function () {
    this.clearTimeout();
    this.isReconnecting = false;
  };
  ReconnectWebsocket.getSingleton = function (config) {
    if (!ReconnectWebsocket.instance) {
      ReconnectWebsocket.instance = new ReconnectWebsocket(config);
    }
    return ReconnectWebsocket.instance;
  };
  return ReconnectWebsocket;
}(EventEmitter.EventEmitter);
var getSingeReconnectableWebsocket = ReconnectWebsocket.getSingleton;
var _a;
var ConnectionError = /** @class */function (_super) {
  getSessionInfo.__extends(ConnectionError, _super);
  function ConnectionError(data) {
    var _this = _super.call(this, (data === null || data === void 0 ? void 0 : data.msg) || 'unknown') || this;
    _this.res = data;
    _this.response = {
      data: data,
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {},
      request: {}
    };
    return _this;
  }
  return ConnectionError;
}(Error);
var DefaultLiveChatConfig = {
  enablePolling: true,
  pollDuration: 10 * 1000,
  msgOvertime: 10 * 1000,
  reSendTimes: 3,
  reSendIncreaseUnit: 2 * 1000 // 重试递增时间
};

var MsgHttpInterface = (_a = {}, _a[MsgHttpType.Message] = getSessionInfo.sendMsg, _a[MsgHttpType.StartSession] = getSessionInfo.sendStartSession, _a[MsgHttpType.CloseSession] = getSessionInfo.sendUserCloseSession, _a);
var InhouseConnection = /** @class */function (_super) {
  getSessionInfo.__extends(InhouseConnection, _super);
  function InhouseConnection(params) {
    if (params === void 0) {
      params = {};
    }
    var _this = _super.call(this) || this;
    _this.seqIdSet = new Set();
    _this.requestTimeout = 10000;
    _this.sessionId = '';
    _this.initMessageId = '';
    _this.userId = '';
    // TODO: keepaliveInterval window 系统可能会提前中断请求, 需确认这里的时间间隔是否需要缩小
    _this.keepaliveInterval = 10000;
    _this.logs = [];
    _this.sequence = 0;
    _this.session_status = http.SessionStatus.Deflected;
    _this.isClosed = false;
    _this.configInfo = {
      queuePositionUpdateSwitchOpen: true
    };
    _this.lastRestoreTime = 0;
    _this.liveChatConfig = DefaultLiveChatConfig;
    _this.isPolling = false;
    _this.msgStatusMap = new Map();
    _this.liveChatConfigReady = false;
    _this.isNormalClosed = true;
    _this.hasOpened = false;
    _this.closeTimeoutTimer = null;
    _this.hasCsJoined = false;
    _this.isClosedByCancelQueue = false;
    _this.isRestore = false;
    _this.wsFinalInitSuccessReport = function () {};
    _this.chatIncomingSuccessReport = function () {};
    _this.unSendMessageList = [];
    _this.entryPoint = constants.DEFAULT_ENTRY_POINT;
    var _a = params.initSession,
      initSession = _a === void 0 ? '' : _a,
      _b = params.userId,
      userId = _b === void 0 ? '' : _b;
    _this.sessionId = initSession;
    _this.userId = userId;
    _this.reconnectableWebsocket = getSingeReconnectableWebsocket({});
    return _this;
  }
  InhouseConnection.prototype.initReconnectableWsEvents = function () {
    var _this = this;
    this.reconnectableWebsocket.on('ping', function () {
      if (_this.isClosed) {
        return;
      }
      _this.ping();
    });
    this.reconnectableWebsocket.on('reconnect', function (data) {
      var _a;
      if (_this.isClosed) {
        return;
      }
      // webSocket重连
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('start reconnect websocket', data);
      _this.pullUnreadMsg().then(function () {
        return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
          var _this = this;
          return getSessionInfo.__generator(this, function (_a) {
            // socket重连次数
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'websocket_reInit_total'
              }
            });
            if (data.count === 1) {
              // socket初次重连次数
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_chat_websocket_first_reInit_total'
                }
              });
            }
            this.createWsConnection({
              forceCreate: true,
              isReconnect: true
            }).then(function (client) {
              var _a;
              if (!(client instanceof Error)) {
                // webSocket重连成功
                (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('reconnect websocket success', {
                  retryTime: data.count
                });
                if (data.count === 1) {
                  // socket初次重连成功次数
                  getSessionInfo.batchReportGrafana({
                    type: 'count',
                    value: {
                      label: 'websocket_first_reInit_success_total'
                    }
                  });
                }
                // socket最终重连成功次数（无论多少次重连）
                getSessionInfo.batchReportGrafana({
                  type: 'count',
                  value: {
                    label: 'websocket_reInit_success_total'
                  }
                });
              }
            });
            return [2 /*return*/];
          });
        });
      });
    });

    this.reconnectableWebsocket.on('error', function (e) {
      _this.reportError('ws_connect_close');
      if (!_this.isClosed) {
        // socket最终重连失败数
        getSessionInfo.batchReportGrafana({
          type: 'count',
          value: {
            label: 'channel_chat_websocket_reinit_final_fail_total'
          }
        });
        // 进线失败异常
        getSessionInfo.batchReportGrafana({
          type: 'count',
          value: {
            label: 'channel_chat_incoming_error_retry_max'
          }
        });
      }
      // this.emitError({
      //   error: new Error('WS_CONNECTION_CLOSE')
      // });
    });
  };
  /**
   * 获取livechat配置
   *
   * @returns
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.toGetLiveChatConfig = function () {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var res, _a, data;
      return getSessionInfo.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            // 只请求一次配置接口
            if (this.liveChatConfigReady) {
              return [2 /*return*/];
            }

            return [4 /*yield*/, getSessionInfo.getLiveChatConfig({
              entry_point: this.entryPoint
            })];
          case 1:
            res = _b.sent();
            if (res instanceof Error) {
              // 接口错误上报但是不中断流程
              this.reportError('cschat_get_live_chat_config_error');
            } else {
              _a = (res || {}).data, data = _a === void 0 ? {} : _a;
              this.liveChatConfig = getSessionInfo.__assign(getSessionInfo.__assign({}, DefaultLiveChatConfig), data || {});
              this.liveChatConfigReady = true;
            }
            return [2 /*return*/, res];
        }
      });
    });
  };
  //todo enquiry为空字符串时候的处理
  InhouseConnection.prototype.connect = function (data) {
    var _a, _b;
    if (data === void 0) {
      data = {
        channel: 0
      };
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var _c, user_entry_type, user_id, user_name, report, newParams, newSessionFunction, _d, sessionData, infoData, _e, queue_x_number, is_show_cancel_queue_button, _f, init_message_id, queue_position_max;
      var _this = this;
      return getSessionInfo.__generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            // 业务进线数
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'channel_chat_incoming_total'
              }
            });
            // 整个进线耗时
            this.chatIncomingSuccessReport = getSessionInfo.batchReportGrafanaTime('channel_chat_incoming_success_time');
            _c = data !== null && data !== void 0 ? data : {}, user_entry_type = _c.user_entry_type, user_id = _c.user_id, user_name = _c.user_name;
            this.setLogger(new getSessionInfo.TraceLogger({
              id: getSessionInfo.getRandomNumbers(),
              sessionId: this.sessionId,
              accountId: user_id,
              accountName: user_name,
              platform: user_entry_type === 1 ? constants.Platform.Mobile : constants.Platform.PC
            }));
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('start connect agent', data);
            this.hasCsJoined = false;
            this.isRestore = false;
            this.isNormalClosed = true;
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'agent_init_total'
              }
            });
            report = getSessionInfo.batchReportGrafanaTime('agent_init_success');
            this.chatbot_dialogue_id = data.chatbot_dialogue_id;
            this.entryPoint = data.entry_point || constants.DEFAULT_ENTRY_POINT;
            this.emit('beforeInit', data);
            // 优先获取配置
            return [4 /*yield*/, this.toGetLiveChatConfig()];
          case 1:
            // 优先获取配置
            _g.sent();
            newParams = {
              chatbot_session_id: data.chatbotSessionId,
              dialogue_id: data.chatbot_dialogue_id,
              channel: data.channel,
              region: data.region,
              message: data.message,
              entry_from_label: data.entry_from_label,
              chat_enquiry_info: getSessionInfo.__assign({
                user_type_id: data.user_type,
                entry_point_id: data.entry_point,
                enquiry_type_id: data.enquiry_type,
                problem_type_id: data.problem_type_id,
                description: data.description,
                attachments: data.attachments,
                order_sn: data.order_sn,
                inbound_order_sn: data.inbound_order_sn,
                subject: data.subject,
                request_phone: data.requester_phone,
                request_email: data.requester_email,
                driver_order_id: data.driver_order_id
              }, (data === null || data === void 0 ? void 0 : data.csFillDatas) || {}),
              bot_enquiry_info: getSessionInfo.__assign(getSessionInfo.__assign({
                session_id: this.sessionId
              }, data), {
                app_entry_point: data.entry_point,
                customer_loyalty_tier: (_b = data.customer_loyalty_tier) === null || _b === void 0 ? void 0 : _b.toString()
              })
            };
            data.app_info && (newParams.app_info = data.app_info);
            newSessionFunction = function newSessionFunction() {
              return _this.mergeNewSession(newParams);
            };
            return [4 /*yield*/, Promise.all([newSessionFunction(), this.getChatInfoWithErrorReport()])];
          case 2:
            _d = _g.sent(), sessionData = _d[0], infoData = _d[1];
            if (sessionData instanceof Error) {
              return [2 /*return*/];
            }

            _e = (infoData === null || infoData === void 0 ? void 0 : infoData.data) || {}, queue_x_number = _e.xnumber, is_show_cancel_queue_button = _e.switch;
            _f = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.data) || {}, init_message_id = _f.init_message_id, queue_position_max = _f.queue_position_max;
            this.initMessageId = init_message_id;
            // 建立长连，但是不阻塞
            this.createWsConnection().then(function (client) {
              if (client instanceof Error) {
                return;
              }
              _this.init(data, getSessionInfo.__assign({
                is_show_cancel_queue_button: is_show_cancel_queue_button,
                queue_x_number: queue_x_number,
                queue_position_max: queue_position_max
              }, (infoData === null || infoData === void 0 ? void 0 : infoData.data) || {}));
              report();
            });
            return [2 /*return*/];
        }
      });
    });
  };

  InhouseConnection.prototype.createWsConnection = function (_a) {
    var _this = this;
    var _b = _a === void 0 ? {
        forceCreate: false,
        isReconnect: false
      } : _a,
      forceCreate = _b.forceCreate,
      isReconnect = _b.isReconnect;
    return new Promise(function (resolve) {
      var _a;
      if (!isReconnect) {
        // 新建会话或者恢复会话，重置重连参数
        _this.reconnectableWebsocket.resetRetryConfig();
      }
      if (!forceCreate && _this.client instanceof WebSocket) {
        resolve(_this.client);
        return;
      }
      _this.updateWsReqId();
      // userId 参数目前只是调试用
      var passGateWay = getSessionInfo.getPassWSGateWay();
      var domain = passGateWay || "" + getHost.getChatbotHost();
      var path = "wss://" + domain + "/chat/v4/ws?req_id=" + _this.wsReqId;
      var wsPathInjector = getWsPathInjector();
      // Socket最终连接耗时
      _this.wsFinalInitSuccessReport = getSessionInfo.batchReportGrafanaTime('channel_chat_websocket_final_init_success_time');
      if (wsPathInjector) {
        path = wsPathInjector(path);
      }
      var client = new WebSocket(path);
      // 单个socket连接耗时
      var report = getSessionInfo.batchReportGrafanaTime('websocket_init_success');
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('websocket init');
      _this.reconnectableWebsocket.setWs(client);
      _this.initReconnectableWsEvents();
      _this.hasOpened = false;
      client.addEventListener('open', function (e) {
        var _a, _b;
        _this.hasOpened = true;
        (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('websocket connected');
        report();
        (_b = _this.wsFinalInitSuccessReport) === null || _b === void 0 ? void 0 : _b.call(_this);
        resolve(client);
        _this.stat(e);
      });
      client.addEventListener('message', function (e) {
        return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
          var data;
          return getSessionInfo.__generator(this, function (_a) {
            data = jsonParse(e.data);
            this.handleMessage(data);
            return [2 /*return*/];
          });
        });
      });

      client.addEventListener('error', function (e) {
        var _a;
        _this.stat(e);
        if (!_this.hasOpened) {
          // socket链接失败数（包括重连失败）
          getSessionInfo.batchReportGrafana({
            type: 'count',
            value: {
              label: 'channel_chat_websocket_init_fail_total'
            }
          });
        }
        // this.emitError(new Error("Web Socket Connect Error"));
        if (isReconnect) {
          // webSocket重连失败
          (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('reconnect websocket fail', {
            error: e
          });
          // socket重连失败数
          getSessionInfo.batchReportGrafana({
            type: 'count',
            value: {
              label: 'channel_chat_websocket_reinit_fail_total'
            }
          });
        }
        // 错误也resolve不阻塞
        resolve(client);
      });
      client.addEventListener('close', function (e) {
        var _a;
        _this.stat(e);
        // isNormalClosed为true代表正常关闭，否则则是异常断开
        if (_this.isNormalClosed) {
          _this.isNormalClosed = false;
        } else {
          // webSocket异常断线
          (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('webSocket close error', {
            error: e
          });
          if (_this.hasOpened) {
            // socket异常断开次数
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'channel_chat_websocket_close_error_total'
              }
            });
          }
        }
        // close也resolve不阻塞
        resolve(client);
        // this.emitError(new Error("WS_CONNECTION_CLOSE"));
      });

      _this.client = client;
      return client;
    });
  };
  InhouseConnection.prototype.init = function (data, extraData) {
    var _a;
    if (extraData === void 0) {
      extraData = {};
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var startSessionParams, _b, _c, session_id, auto_close_timeout, chatting_agent_info, _d, _e, _f, queue_position_update_switch_open, code, _g, agent_id, agent_name;
      return getSessionInfo.__generator(this, function (_h) {
        switch (_h.label) {
          case 0:
            startSessionParams = data.startSessionParams;
            return [4 /*yield*/, this.startSession(getSessionInfo.__assign({}, startSessionParams))];
          case 1:
            _b = _h.sent() || {
              data: {}
            }, _c = _b.data, session_id = _c.session_id, auto_close_timeout = _c.auto_close_timeout, chatting_agent_info = _c.chatting_agent_info, _d = _c.config_info, _e = _d === void 0 ? {} : _d, _f = _e.queue_position_update_switch_open, queue_position_update_switch_open = _f === void 0 ? true : _f, code = _b.code;
            if (code != 0) {
              // 业务进线失败数
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_chat_incoming_fail_total'
                }
              });
              return [2 /*return*/];
            }
            // 开启轮询
            this.startPolling();
            this.configInfo = getSessionInfo.__assign(getSessionInfo.__assign({}, this.configInfo), {
              queuePositionUpdateSwitchOpen: queue_position_update_switch_open
            });
            this.emit('init', {
              id: session_id,
              key: session_id,
              shopeeChatKey: session_id,
              clientPollTimeout: auto_close_timeout,
              enquiryName: data.enquiry_name,
              init_message_id: this.initMessageId,
              is_show_cancel_queue_button: extraData.is_show_cancel_queue_button,
              queue_x_number: extraData.queue_x_number,
              queue_position_max: extraData.queue_position_max
            });
            this.emit('config', getSessionInfo.__assign({}, this.configInfo));
            // 如果当前会话已经是聊天状态, 模拟第一次接入
            if (this.session_status === http.SessionStatus.Chatting) {
              _g = chatting_agent_info || {}, agent_id = _g.agent_id, agent_name = _g.agent_name;
              this.emit('message', {
                msg_type: 'QUEUING',
                content: {
                  number: 1,
                  estimated_wait_time: 0
                }
              });
              this.emit('message', {
                msg_type: 'CS_JOINED',
                content: {
                  cs_id: agent_id === null || agent_id === void 0 ? void 0 : agent_id.toString(),
                  cs_name: agent_name
                }
              });
              (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('chat is already joined');
            }
            if (this.session_status === http.SessionStatus.End) {
              this.emitClose({
                msg: 'SESSION_END_WHEN_RESTORE'
              });
            }
            return [2 /*return*/];
        }
      });
    });
  };

  InhouseConnection.prototype.stat = function (message) {
    this.logs.push(message);
    this.emit('stat', message, this.logs);
  };
  InhouseConnection.prototype.ping = function () {
    var _a;
    (_a = this.client) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
      cmd: 'PING',
      request_id: getSessionInfo.getRandomNumbers()
    }));
  };
  InhouseConnection.prototype.sendWsContent = function (params, retryTime) {
    var _this = this;
    var _a;
    if (retryTime === void 0) {
      retryTime = 3;
    }
    var retryTimeout = 500;
    var biz_content = params.biz_content,
      restParams = getSessionInfo.__rest(params, ["biz_content"]);
    var requestId = getSessionInfo.getRandomNumbers();
    if (((_a = this === null || this === void 0 ? void 0 : this.client) === null || _a === void 0 ? void 0 : _a.readyState) !== 1) {
      // 如果发消息时连接还未建立成功, 500ms 后再次尝试发送, 最多重试3次
      if (retryTime !== 0) {
        setTimeout(function () {
          _this.sendWsContent(params, retryTime - 1);
        }, retryTimeout);
      }
      return;
    }
    try {
      this.client.send(JSON.stringify(getSessionInfo.__assign(getSessionInfo.__assign({}, restParams), {
        biz_content: JSON.stringify(biz_content),
        request_id: requestId
      })));
    } catch (e) {
      console.error(e);
      this.stat(e);
      return e;
    }
  };
  /**
   *  通过http发送消息
   *
   * @param {*} content
   * @param {boolean} [isRetry]
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.sendContentByHttp = function (type, msg, isRetry, retryTime) {
    var _this = this;
    var _a = msg.msg_id,
      msg_id = _a === void 0 ? '' : _a;
    if (!retryTime) {
      // 第一次发送消息，上报消息发送数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'cschat_message_send_total',
          extend_1: type
        }
      });
      this.msgStatusMap.set(msg_id, MsgStatus.Sending);
    }
    // 发送耗时
    var report = getSessionInfo.batchReportGrafanaTime('cschat_message_send_success_final_time');
    // 获取配置
    var _b = this.liveChatConfig,
      reSendTimes = _b.reSendTimes,
      reSendIncreaseUnit = _b.reSendIncreaseUnit,
      msgOvertime = _b.msgOvertime;
    // 第一次发送，默认取配置
    var currentRetryTime = retryTime === undefined ? reSendTimes : retryTime;
    var sendApi = MsgHttpInterface[type] || MsgHttpInterface[MsgHttpType.Message];
    return new Promise(function (resolve, reject) {
      return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
        var res, reSendDelay;
        var _this = this;
        var _a, _b, _c;
        return getSessionInfo.__generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              return [4 /*yield*/, sendApi(msg, {
                timeout: msgOvertime
              })];
            case 1:
              res = _d.sent();
              // 发送失败或者超时进入逻辑判断
              if (res instanceof Error) {
                // 判断是否要重试
                if (currentRetryTime > 0 && isRetry && this.checkRetry(res)) {
                  // 消息状态不是sending状态下不再重试，可能ws的ack已经返回
                  if (this.msgStatusMap.get(msg_id) !== MsgStatus.Sending) {
                    return [2 /*return*/];
                  }
                  // 第一次重发的时候上报
                  if (currentRetryTime === reSendTimes - 1) {
                    getSessionInfo.batchReportGrafana({
                      type: 'count',
                      value: {
                        label: 'cschat_message_first_resend_total'
                      }
                    });
                  }
                  reSendDelay = Math.abs(reSendTimes - currentRetryTime) * reSendIncreaseUnit;
                  setTimeout(function () {
                    // 消息状态不是sending状态下不再重试，可能ws的ack已经返回
                    if (_this.msgStatusMap.get(msg_id) !== MsgStatus.Sending) {
                      return;
                    }
                    _this.sendContentByHttp(type, msg, isRetry, currentRetryTime - 1).then(function (data) {
                      resolve(data);
                    }).catch(function (error) {
                      reject(error);
                    });
                  }, reSendDelay);
                } else {
                  // 重试次数到了，不需要重试,返回失败
                  getSessionInfo.batchReportGrafana({
                    type: 'count',
                    value: {
                      label: 'cschat_message_send_fail_total'
                    }
                  });
                  // 由于超时导致的失败上报
                  if (!((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status)) {
                    getSessionInfo.batchReportGrafana({
                      type: 'count',
                      value: {
                        label: 'cschat_message_send_timeout_total'
                      }
                    });
                    // 保留原有的打点
                    (_c = this.logger) === null || _c === void 0 ? void 0 : _c.error('send_message recive_server_ack_timeout', msg);
                    if (msg.msg_type === 'IMG') {
                      getSessionInfo.batchReportGrafana({
                        type: 'count',
                        value: {
                          label: 'send_image_message_timeout'
                        }
                      });
                    }
                  }
                  reject(res);
                }
              } else {
                // 成功
                // 第一次就成功，上报
                if (!retryTime) {
                  getSessionInfo.batchReportGrafana({
                    type: 'count',
                    value: {
                      label: 'cschat_message_send_first_success_total'
                    }
                  });
                }
                // 重发成功
                else {
                  getSessionInfo.batchReportGrafana({
                    type: 'count',
                    value: {
                      label: 'cschat_message_final_resend_success_total'
                    }
                  });
                }
                report();
                resolve(res === null || res === void 0 ? void 0 : res.data);
              }
              return [2 /*return*/];
          }
        });
      });
    });
  };
  /**
   * 通过http发送ack
   *
   * @param {string} requestId
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.sendClientAck = function (requestId) {
    return getSessionInfo.sendAck({
      session_id: this.sessionId,
      acked: requestId
    });
  };
  // websocket 等推送就行了, 这里不需要做任何操作
  InhouseConnection.prototype.getMessage = function () {};
  /**
   * 更新sequence，这里将sequence缓存在localstorage中，防止刷新时无法获取之前最新的消息
   *
   * @param {(string | number)} sequence
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.updateSequence = function (sequence) {
    this.sequence = sequence;
    getSessionInfo.setStorage('sequence', this.sequence);
  };
  /**
   *
   *
   * @param {() => void} report
   * @returns
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.doAfterRestore = function (report) {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var startRestore;
      var _this = this;
      return getSessionInfo.__generator(this, function (_a) {
        this.isRestore = true;
        startRestore = function startRestore() {
          return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, queue_position_update_switch_open, code;
            var _e, _f;
            return getSessionInfo.__generator(this, function (_g) {
              switch (_g.label) {
                case 0:
                  return [4 /*yield*/, this.getSessionInfo()];
                case 1:
                  _a = _g.sent() || {
                    data: {}
                  }, _b = _a.data.config_info, _c = _b === void 0 ? {} : _b, _d = _c.queue_position_update_switch_open, queue_position_update_switch_open = _d === void 0 ? true : _d, code = _a.code;
                  if (code != 0) {
                    (_e = this.logger) === null || _e === void 0 ? void 0 : _e.debug('recover chat failed');
                    return [2 /*return*/];
                  }

                  report();
                  this.configInfo = getSessionInfo.__assign(getSessionInfo.__assign({}, this.configInfo), {
                    queuePositionUpdateSwitchOpen: queue_position_update_switch_open
                  });
                  this.emit('config', getSessionInfo.__assign({}, this.configInfo));
                  this.startPolling();
                  this.emit('restoreSuccess');
                  (_f = this.logger) === null || _f === void 0 ? void 0 : _f.debug('recover chat success');
                  return [2 /*return*/];
              }
            });
          });
        };

        this.createWsConnection().then(function (client) {
          return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return getSessionInfo.__generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (!(client instanceof Error)) {
                    // 恢复聊天成功
                    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('recover ws connection success');
                  }
                  return [4 /*yield*/, startRestore()];
                case 1:
                  _b.sent();
                  return [2 /*return*/];
              }
            });
          });
        });

        return [2 /*return*/];
      });
    });
  };

  InhouseConnection.prototype.restore = function (_a, _b, data) {
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var sessionId = _a.sessionId,
      sequence = _a.sequence,
      entryPoint = _a.entryPoint;
    var _p = _b === void 0 ? {} : _b,
      _q = _p.shouldPullUnreadMsg,
      shouldPullUnreadMsg = _q === void 0 ? true : _q;
    if (data === void 0) {
      data = {};
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var report;
      var _this = this;
      return getSessionInfo.__generator(this, function (_r) {
        switch (_r.label) {
          case 0:
            if (entryPoint) {
              this.entryPoint = entryPoint;
            }
            // App chatbot 存在一个偶现问题，会同时创建多个 websocket
            // 暂时加上这个 看是否可以避免
            if (this.client && Date.now() - this.lastRestoreTime < 100) {
              return [2 /*return*/, this];
            }
            this.lastRestoreTime = Date.now();
            this.setLogger(new getSessionInfo.TraceLogger({
              id: getSessionInfo.getRandomNumbers(),
              sessionId: sessionId,
              accountId: (_d = (_c = this.logger) === null || _c === void 0 ? void 0 : _c.commonParams) === null || _d === void 0 ? void 0 : _d.accountId,
              accountName: (_f = (_e = this.logger) === null || _e === void 0 ? void 0 : _e.commonParams) === null || _f === void 0 ? void 0 : _f.accountName,
              platform: (_h = (_g = this.logger) === null || _g === void 0 ? void 0 : _g.commonParams) === null || _h === void 0 ? void 0 : _h.platform
            }));
            // 恢复聊天
            (_j = this.logger) === null || _j === void 0 ? void 0 : _j.debug('start restore chat', data);
            this.isNormalClosed = true;
            report = getSessionInfo.batchReportGrafanaTime('agent_restore_success');
            // 关闭已有的连接(如果有)
            (_l = (_k = this.client) === null || _k === void 0 ? void 0 : _k.close) === null || _l === void 0 ? void 0 : _l.call(_k, 1000);
            this.emit('restore', data);
            this.sessionId = sessionId;
            (_o = (_m = this.logger) === null || _m === void 0 ? void 0 : _m.updateSessionId) === null || _o === void 0 ? void 0 : _o.call(_m, this.sessionId);
            if (sequence) {
              this.updateSequence(sequence);
            }
            // 2022.6.8 restore时，重新拉取配置以及开启轮询
            return [4 /*yield*/, this.toGetLiveChatConfig()];
          case 1:
            // 2022.6.8 restore时，重新拉取配置以及开启轮询
            _r.sent();
            if (!!shouldPullUnreadMsg) return [3 /*break*/, 3];
            return [4 /*yield*/, this.doAfterRestore(report)];
          case 2:
            _r.sent();
            return [2 /*return*/, this];
          case 3:
            this.pullUnreadMsg().then(function () {
              return getSessionInfo.__awaiter(_this, void 0, void 0, function () {
                return getSessionInfo.__generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, this.doAfterRestore(report)];
                    case 1:
                      _a.sent();
                      return [2 /*return*/];
                  }
                });
              });
            });

            return [2 /*return*/, this];
        }
      });
    });
  };
  // 2022.11.11 新的session接口，合并了uploadChatbotMessage与uploadEnquireInfo接口
  InhouseConnection.prototype.mergeNewSession = function (params) {
    var _a, _b, _c, _d;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var msg, res, session_id;
      return getSessionInfo.__generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            msg = getSessionInfo.__assign({}, params);
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('new session', msg);
            return [4 /*yield*/, getSessionInfo.createNewSession(params)];
          case 1:
            res = _e.sent();
            if (res instanceof Error) {
              this.reportError('new_session');
              // 上传chatbot消息失败
              this.emitError({
                error: res,
                message: 'new session error'
              });
              // 业务进线失败数
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_chat_incoming_fail_total'
                }
              });
              return [2 /*return*/, res];
            }
            session_id = (res || {
              data: {}
            }).data.session_id;
            // 以前使用uploadChatbotMessage接口的时候，若用户已有正在使用的进线，接口返回空的session_id
            // 但改为使用init_session接口之后，后端确认一定不会有返回空session_id的情况，所以出现这种情况肯定是异常了，需要上报进线失败
            if (!session_id) {
              // 上报一个记录
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_new_session_repeat'
                }
              });
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_chat_incoming_fail_total'
                }
              });
              (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('channel new session repeat', {
                error: res
              });
              // 抛出错误以中断后续流程
              return [2 /*return*/, new Error('channel new session repeat')];
            }
            this.sessionId = session_id;
            (_d = (_c = this.logger) === null || _c === void 0 ? void 0 : _c.updateSessionId) === null || _d === void 0 ? void 0 : _d.call(_c, this.sessionId);
            return [2 /*return*/, res];
        }
      });
    });
  };
  InhouseConnection.prototype.newSession = function (params) {
    var _a, _b, _c, _d;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var res, session_id;
      return getSessionInfo.__generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            // 上传chatbot消息
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('upload chatbot message');
            return [4 /*yield*/, getSessionInfo.uploadChatbotMessage(params)];
          case 1:
            res = _e.sent();
            if (res instanceof Error) {
              this.reportError('upload_chatbot_message');
              // 上传chatbot消息失败
              this.emitError({
                error: res,
                message: 'upload chatbot message error'
              });
              // 业务进线失败数
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_chat_incoming_fail_total'
                }
              });
              return [2 /*return*/, res];
            }
            session_id = res.data.session_id;
            // 特殊场景下，当前用户已有正在使用的进线，uploadChatbotMessage返回空的session_id
            if (!session_id) {
              // 上报一个记录
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_upload_chatbot_message_repeat'
                }
              });
              (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('channel upload chatbot message repeat', {
                error: res
              });
              // 抛出错误以中断后续流程
              return [2 /*return*/, new Error('channel upload chatbot message repeat')];
            }
            this.sessionId = session_id;
            (_d = (_c = this.logger) === null || _c === void 0 ? void 0 : _c.updateSessionId) === null || _d === void 0 ? void 0 : _d.call(_c, this.sessionId);
            return [2 /*return*/, res];
        }
      });
    });
  };
  /**
   * 获取session信息
   *
   * @returns
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.getSessionInfo = function () {
    var _this = this;
    var msg = {
      session_id: this.sessionId
    };
    return getSessionInfo.getSessionInfo(msg).then(function (res) {
      var _a;
      if (res instanceof Error) {
        throw res;
      }
      var code = res.code,
        data = res.data;
      if (code === 0) {
        _this.sessionId = (data === null || data === void 0 ? void 0 : data.session_id) || _this.sessionId;
        _this.session_status = (data === null || data === void 0 ? void 0 : data.session_status) || _this.session_status;
        (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('get session info done', data);
        return res;
      }
      throw new Error(JSON.stringify(res));
    }).catch(function (err) {
      var _a;
      _this.reportError('get_session_info_error');
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('getSessionInfo error', {
        msg: msg,
        error: err
      });
      _this.emitError(err);
    });
  };
  /**
   * 使用http发送startSession
   *
   * @param {Partial<StartSessionBizContentType>} [bizContent]
   * @returns {Promise<BaseRes<StartSessionAckBizContentType>>}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.startSessionByHttp = function (bizContent) {
    var _this = this;
    var msg = getSessionInfo.__assign({
      session_id: this.sessionId
    }, bizContent);
    return new Promise(function (resolve, reject) {
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'cschat_send_start_session_total'
        }
      });
      _this.sendContentByHttp(MsgHttpType.StartSession, msg, false).then(function (data) {
        resolve(data || {});
      }).catch(function (err) {
        reject(err);
      });
      _this.once('START_SESSION_RESPONSE', function (data) {
        resolve(data);
      });
    }).then(function (data) {
      var _a;
      _this.sessionId = (data === null || data === void 0 ? void 0 : data.session_id) || _this.sessionId;
      _this.session_status = (data === null || data === void 0 ? void 0 : data.session_status) || _this.session_status;
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('start session done', data);
      return {
        code: 0,
        msg: '',
        data: data
      };
    }).catch(function (err) {
      var _a;
      _this.reportError('start_session_error');
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('startSession error', {
        msg: msg,
        error: err
      });
      _this.emitError(err);
    });
  };
  /**
   *根据配置，使用不同的通道发送startSession
   *
   * @param {Partial<StartSessionBizContentType>} [bizContent]
   * @returns {Promise<BaseRes<StartSessionAckBizContentType>>}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.startSession = function (bizContent) {
    return this.startSessionByHttp(bizContent);
  };
  /**
   * 使用http发送消息
   *
   * @param {SendMessageBizContentType} bizContent
   * @returns {(Promise<SendMessageResType | Error>)}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.sendMessageByHttp = function (bizContent, config) {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var content, restBizContent, _a, isRetry, msg_id, msg, promise;
      var _this = this;
      return getSessionInfo.__generator(this, function (_b) {
        content = bizContent.content, restBizContent = getSessionInfo.__rest(bizContent, ["content"]);
        _a = (config || {}).isRetry, isRetry = _a === void 0 ? true : _a;
        msg_id = getSessionInfo.getRandomNumbers();
        msg = getSessionInfo.__assign({
          session_id: this.sessionId,
          msg_id: msg_id,
          user_type: http.UserType.Anonymous,
          content: typeof content === 'string' ? content : JSON.stringify(getSessionInfo.__assign({}, content))
        }, restBizContent);
        promise = new Promise(function (resolve) {
          var _a;
          _this.sendContentByHttp(MsgHttpType.Message, msg, isRetry).then(function (data) {
            resolve({
              code: 0,
              data: getSessionInfo.__assign(getSessionInfo.__assign(getSessionInfo.__assign({}, msg), data), {
                content: content
              })
            });
          }).catch(function (error) {
            var _a;
            (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('send message error', {
              msg: msg,
              error: error
            });
            resolve(error);
          });
          // 仍然保留ack的逻辑
          var taskId = 'ASK_MSG:' + bizContent.msg_type + ':' + ((_a = restBizContent.msg_id) !== null && _a !== void 0 ? _a : msg_id);
          _this.once(taskId, function (data) {
            resolve({
              code: 0,
              data: getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
                content: content
              })
            });
          });
        });
        // 保留原有打点
        if (bizContent.msg_type === 'IMG') {
          getSessionInfo.batchReportGrafana({
            type: 'count',
            value: {
              label: 'send_image_message'
            }
          });
        }
        return [2 /*return*/, promise.then(function (value) {
          // 无论成功还是失败,删除这条msg的记录
          var _a = msg.msg_id,
            msg_id = _a === void 0 ? '' : _a;
          _this.msgStatusMap.delete(msg_id);
          if (value instanceof Error) {
            _super.prototype.emitMessageComplete.call(_this, {
              result: bizContent,
              error: value
            });
          } else {
            _super.prototype.emitMessageComplete.call(_this, {
              result: getSessionInfo.__assign(getSessionInfo.__assign({}, value), bizContent)
            });
          }
          return value;
        })];
      });
    });
  };
  /**
   * 根据配置，使用不同的通道发送消息
   *
   * @param {SendMessageBizContentType} bizContent
   * @returns {(Promise<SendMessageResType | Error>)}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.sendMessage = function (bizContent, config) {
    return this.sendMessageByHttp(bizContent, config);
  };
  // 这个接口可以往前拉取历史消息
  InhouseConnection.prototype.pullHistoryByWS = function (bizContent, callback) {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var _this = this;
      return getSessionInfo.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.startSession()];
          case 1:
            _a.sent();
            if (this.session_status === http.SessionStatus.End) {
              this.emitClose({
                msg: 'SESSION_END_WHEN_PULL_HISTORY'
              });
              return [2 /*return*/, {
                code: 0,
                data: []
              }];
            }
            return [2 /*return*/, new Promise(function (resolve) {
              _this.sendWsContent({
                cmd: 'CLIENT_SEND',
                biz_type: 'PULL_HISTORY_MSGS',
                biz_content: getSessionInfo.__assign({
                  session_id: _this.sessionId,
                  user_type: http.UserType.Anonymous,
                  by_seq: {
                    req_type: 2,
                    seq_id: _this.sequence,
                    limit: 50
                  }
                }, bizContent)
              });
              _this.once('HISTORY_MSGS_RES', function (data) {
                var _a, _b, _c, _d;
                var formatData = {
                  code: 0,
                  data: (_b = (_a = data.body) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, function (e) {
                    return getSessionInfo.__assign(getSessionInfo.__assign({}, e), {
                      content: jsonParse(e.content)
                    });
                  })
                };
                (_d = (_c = formatData.data) === null || _c === void 0 ? void 0 : _c.forEach) === null || _d === void 0 ? void 0 : _d.call(_c, function (message) {
                  if (_this.seqIdSet.has(message.seq_id)) {
                    console.warn('Duplicate seq id of: ', message.seq_id, message);
                    return;
                  }
                  _this.seqIdSet.add(message.seq_id);
                  _this.emit('message', message);
                });
                callback === null || callback === void 0 ? void 0 : callback(formatData);
                resolve(formatData);
              });
            })];
        }
      });
    });
  };
  InhouseConnection.prototype.handleReceiveMessage = function (data) {
    var _a, _b, _c, _d;
    var msg_type = data.msg_type,
      seq_id = data.seq_id;
    if (this.seqIdSet.has(seq_id)) {
      console.warn('Duplicate seq id of: ', seq_id, data);
      return;
    }
    this.seqIdSet.add(seq_id);
    this.updateSequence(seq_id);
    // 用户关闭 session
    if ([constants.MSG_TYPES.USER_CLOSE_SESSION, constants.MSG_TYPES.CS_CLOSE_SESSION, constants.MSG_TYPES.SESSION_CLOSE_TIMEOUT, constants.MSG_TYPES.EVENT_SESSION_CLOSED, constants.MSG_TYPES.CHASING_USER_CLOSE_SESSION, constants.MSG_TYPES.CHASING_TIMEOUT_CLOSE_SESSION].includes(msg_type)) {
      /**
       * data: {
       *  cs_name: string;
       *  cs_id: string;
       * }
       */
      this.emitClose({
        // EVENT_SESSION_CLOSED与SESSION_CLOSED展示方式相同，直接将EVENT_SESSION_CLOSED类型转为SESSION_CLOSED
        msg: msg_type === constants.MSG_TYPES.EVENT_SESSION_CLOSED ? constants.MSG_TYPES.SESSION_CLOSED : msg_type,
        data: data,
        _messageType_: (_a = data._messageType_) !== null && _a !== void 0 ? _a : http.MessageType.RealTimeMessage,
        _unreadMsgCount_: data._unreadMsgCount_
      });
      return;
    }
    if (['NO_VALID_AGENT'].includes(msg_type)) {
      this.emitClose({
        code: constants.GetMsgResCode.LIVE_OFFLINE_ERROR_CODE,
        msg: msg_type,
        data: data
      });
      return;
    }
    if (['TRANSFER_SESSION'].includes(msg_type)) {
      this.emit('message', data);
      return;
    }
    if (msg_type === 'QUEUING') {
      this.emit('message', data);
      // 排队中
      (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('chat is queuing', data);
      return;
    }
    if (msg_type === 'AGENT_TYPING') {
      this.emit('message', data);
      return;
    }
    if (msg_type === 'CS_JOINED') {
      this.emit('message', data);
      // 进线成功
      (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug('chat just joined', data);
      // 进线成功数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'channel_chat_incoming_success_total'
        }
      });
      (_d = this.chatIncomingSuccessReport) === null || _d === void 0 ? void 0 : _d.call(this);
      this.hasCsJoined = true;
      return;
    }
    // 其他消息类型,直接抛出
    this.emit('message', data);
  };
  // inhouse 的未读消息是包括用户发送的消息的,这里过滤下保持统一
  InhouseConnection.prototype.pullUnreadMsg = function (bizContent, callback) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var res, code, formatData;
      var _this = this;
      return getSessionInfo.__generator(this, function (_k) {
        switch (_k.label) {
          case 0:
            // 进线成功
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('start pull unread msg', bizContent);
            return [4 /*yield*/, getSessionInfo.unreadMessage(getSessionInfo.__assign({
              session_id: this.sessionId,
              seq_id: this.sequence || 0
            }, bizContent))];
          case 1:
            res = _k.sent();
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('pull unread msg done', {
              result: res
            });
            if (res instanceof Error) {
              code = (((_d = (_c = res) === null || _c === void 0 ? void 0 : _c.response) === null || _d === void 0 ? void 0 : _d.data) || {}).code;
              if (code === ErrorCode.SessionExpires) {
                (_e = this.logger) === null || _e === void 0 ? void 0 : _e.debug('pull unread msg, SessionExpires', {
                  error: res
                });
                // 终止后面流程
                this.stop();
                throw res;
              }
              return [2 /*return*/, res];
            }
            formatData = getSessionInfo.__assign(getSessionInfo.__assign({}, res), {
              code: 0,
              data: (_g = (_f = res.data.unread_msgs) === null || _f === void 0 ? void 0 : _f.map) === null || _g === void 0 ? void 0 : _g.call(_f, function (e) {
                return getSessionInfo.__assign(getSessionInfo.__assign({}, e), {
                  content: jsonParse(e.content)
                });
              })
            });
            (_j = (_h = formatData.data) === null || _h === void 0 ? void 0 : _h.forEach) === null || _j === void 0 ? void 0 : _j.call(_h, function (message) {
              if (message.user_type !== http.UserType.LocalCS && message.user_type !== http.UserType.Sys && message.user_type !== http.UserType.SERVICE_ASSISTANT) {
                if (message.msg_type === constants.MSG_TYPES.NO_VALID_AGENT) {
                  var error = new ConnectionError({
                    code: constants.GetMsgResCode.LIVE_OFFLINE_ERROR_CODE,
                    msg: message.msg_type,
                    data: getSessionInfo.__assign({
                      init_message_id: _this.initMessageId
                    }, message.content)
                  });
                  // 无客服状态数
                  _this.reportError('no_valid_agent');
                  _this.emitError({
                    error: error
                  });
                  return;
                }
                if (message.msg_type !== constants.MSG_TYPES.SESSION_CLOSE_TIMEOUT && message.msg_type !== constants.MSG_TYPES.EVENT_SESSION_CLOSED) {
                  return;
                }
              }
              _this.handleReceiveMessage(getSessionInfo.__assign({
                _messageType_: http.MessageType.UnreadMessage,
                _unreadMsgCount_: formatData.data.length
              }, message));
            });
            callback === null || callback === void 0 ? void 0 : callback(res);
            return [2 /*return*/, res];
        }
      });
    });
  };
  /**
   * 使用http发送closeSession
   *
   * @param {CloseSessionBizContentType} [bizContent]
   * @param {(data: CloseSessionAckBizContentType) => void} [callback]
   * @returns {Promise<CloseSessionAckBizContentType>}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.closeSessionByHttp = function (bizContent, callback, closeMsg) {
    var _this = this;
    return new Promise(function (resolve) {
      var msg_id = getSessionInfo.getRandomNumbers();
      var msg = {
        session_id: _this.sessionId,
        msg_id: msg_id,
        biz_content: getSessionInfo.__assign({}, bizContent)
      };
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'cschat_send_close_session_total'
        }
      });
      _this.sendContentByHttp(MsgHttpType.CloseSession, msg, true).then(function (data) {
        callback === null || callback === void 0 ? void 0 : callback(data);
        // 无论成功还是失败,删除这条msg的记录
        _this.msgStatusMap.delete(msg_id);
        resolve(data);
      }).catch(function () {
        var _a, _b;
        _this.msgStatusMap.delete(msg_id);
        _this.reportError('user_close_session_error');
        // 结束聊天失败
        (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('end chat error', {
          msg: msg
        });
        if (closeMsg === constants.MSG_TYPES.CANCEL_QUEUE) {
          // 取消排队失败
          (_b = _this.logger) === null || _b === void 0 ? void 0 : _b.error('cancel chat error');
          _this.isClosedByCancelQueue = false;
        }
        // chat不正常关闭数
        getSessionInfo.batchReportGrafana({
          type: 'count',
          value: {
            label: 'channel_chat_user_close_session_error_total'
          }
        });
      });
      _this.once('SEND_MSG:USER_CLOSE_SESSION', function (data) {
        callback === null || callback === void 0 ? void 0 : callback(data);
        // 无论成功还是失败,删除这条msg的记录
        _this.msgStatusMap.delete(msg_id);
        resolve(data);
      });
    }).then(function (data) {
      var _a;
      (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug('user close session', {
        msg: data
      });
      return data;
    });
  };
  /**
   * 根据配置，使用不同的通道发送closeSession
   *
   * @param {CloseSessionBizContentType} [bizContent]
   * @param {(data: CloseSessionAckBizContentType) => void} [callback]
   * @returns {Promise<CloseSessionAckBizContentType>}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.closeSession = function (bizContent, callback, msg) {
    return this.closeSessionByHttp(bizContent, callback, msg);
  };
  /**
   * 手动关闭连接
   */
  InhouseConnection.prototype.close = function (data) {
    if (data === void 0) {
      data = {
        msg: 'MANUAL_CLOSE'
      };
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (data.msg === constants.MSG_TYPES.CANCEL_QUEUE) {
              this.isClosedByCancelQueue = true;
            }
            return [4 /*yield*/, this.closeSession({}, function () {}, data === null || data === void 0 ? void 0 : data.msg)];
          case 1:
            _a.sent();
            this.emitClose(data);
            return [2 /*return*/];
        }
      });
    });
  };

  InhouseConnection.prototype.stop = function () {
    var _a, _b;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_c) {
        this.isClosed = true;
        this.isNormalClosed = true;
        // 关闭轮询
        this.stopPolling();
        this.removeAllListeners();
        (_b = (_a = this.client) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 ? void 0 : _b.call(_a, 1000);
        return [2 /*return*/];
      });
    });
  };

  InhouseConnection.prototype.emitClose = function (data) {
    var _a, _b, _c, _d, _e, _f;
    if (this.isClosed) {
      return;
    }
    var normalClose = [constants.MSG_TYPES.SESSION_CLOSED, constants.MSG_TYPES.USER_CLOSE_SESSION, constants.MSG_TYPES.CS_CLOSE_SESSION, constants.MSG_TYPES.CHASING_USER_CLOSE_SESSION, constants.MSG_TYPES.CHASING_TIMEOUT_CLOSE_SESSION, 'close by avatar click' // APP客服加入点击三下也会触发close
    ].includes(data === null || data === void 0 ? void 0 : data.msg);
    if (normalClose) {
      this.isNormalClosed = true;
      // chat正常关闭数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'channel_chat_incoming_end_total'
        }
      });
    }
    this.isClosed = true;
    // 关闭轮询
    this.stopPolling();
    if (this.isClosedByCancelQueue && (data === null || data === void 0 ? void 0 : data.msg) === constants.MSG_TYPES.USER_CLOSE_SESSION) {
      // 取消排队，为了防止用户手动取消排队后，后端返回的USER_CLOSE_SESSION，导致关闭原因异常，这里主动将close原因置为取消排队
      (_a = this === null || this === void 0 ? void 0 : this.emit) === null || _a === void 0 ? void 0 : _a.call(this, 'close', getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
        msg: constants.MSG_TYPES.CANCEL_QUEUE,
        ratingId: getSessionInfo.getRandomNumbers()
      }));
    } else {
      (_b = this === null || this === void 0 ? void 0 : this.emit) === null || _b === void 0 ? void 0 : _b.call(this, 'close', getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
        ratingId: getSessionInfo.getRandomNumbers()
      }));
    }
    this.removeAllListeners();
    (_d = (_c = this.client) === null || _c === void 0 ? void 0 : _c.close) === null || _d === void 0 ? void 0 : _d.call(_c, 1000);
    this.closeTimeoutTimer && clearTimeout(this.closeTimeoutTimer);
    (_e = this.logger) === null || _e === void 0 ? void 0 : _e.debug('chat has been closed', data);
    if ((data === null || data === void 0 ? void 0 : data.msg) === constants.MSG_TYPES.CANCEL_QUEUE || this.isClosedByCancelQueue) {
      this.isClosedByCancelQueue = false;
      // 取消排队成功
      (_f = this.logger) === null || _f === void 0 ? void 0 : _f.debug('cancel chat success');
      // 进线取消成功数
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'channel_chat_incoming_cancel_success_total'
        }
      });
    }
  };
  InhouseConnection.prototype.emitError = function (options) {
    var _a, _b, _c, _d;
    if (this.isClosed) {
      return;
    }
    var error = options.error,
      message = options.message;
    this.isClosed = true;
    // 关闭轮询
    this.stopPolling();
    (_a = this === null || this === void 0 ? void 0 : this.emit) === null || _a === void 0 ? void 0 : _a.call(this, 'error', error, {
      shouldClose: true
    });
    // 触发了 error 事件之后就不会触发 close, 发生异常后去掉所有监听器
    this.removeAllListeners();
    this.isNormalClosed = false;
    (_c = (_b = this.client) === null || _b === void 0 ? void 0 : _b.close) === null || _c === void 0 ? void 0 : _c.call(_b, 1000);
    (_d = this.logger) === null || _d === void 0 ? void 0 : _d.error('chat error occurred', {
      error: error,
      message: message
    });
  };
  InhouseConnection.prototype.reportError = function (label) {
    if (this.chat_status === ChatStatus.Init) {
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: 'agent_init_error_total'
        }
      });
      getSessionInfo.batchReportGrafana({
        type: 'count',
        value: {
          label: "channel_chat_websocket_init_error_" + label
        }
      });
    }
    getSessionInfo.batchReportGrafana({
      type: 'count',
      value: {
        label: "agent_error_" + label + "_total"
      }
    });
    getSessionInfo.batchReportGrafana({
      type: 'count',
      value: {
        label: 'agent_inhouse_error_total'
      }
    });
  };
  InhouseConnection.prototype.rating = function (data) {
    return getSessionInfo.sendRating(getSessionInfo.__assign({
      sessionId: this.sessionId
    }, data));
  };
  InhouseConnection.prototype.setLogger = function (logger) {
    this.logger = logger;
    this.reconnectableWebsocket.setLogger(logger);
  };
  InhouseConnection.prototype.updateWsReqId = function () {
    var _a;
    this.wsReqId = getSessionInfo.getRandomNumberWithTimeStamp();
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.setWsReqId(this.wsReqId);
  };
  /**
   * 开启定时轮询
   *
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.startPolling = function () {
    var _this = this;
    var _a;
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('channel polling msg start');
    var _b = this.liveChatConfig,
      enablePolling = _b.enablePolling,
      pollDuration = _b.pollDuration;
    var startTimer = function startTimer() {
      setTimeout(function () {
        if (!_this.isPolling) {
          return;
        }
        _this.pollingMsg();
        startTimer();
      }, pollDuration);
    };
    if (enablePolling && !this.isPolling) {
      this.isPolling = true;
      this.pollingMsg();
      startTimer();
    }
  };
  /**
   * 停止定时轮询
   *
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.stopPolling = function () {
    var _a;
    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('channel polling msg stop');
    this.isPolling = false;
  };
  /**
   * 拉取消息
   *
   * @returns
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.pollingMsg = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var pollingMsgReport, pollingMessageAPI, res, code, _h, unread_msgs, session_status, messageList;
      var _this = this;
      return getSessionInfo.__generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'channel_polling_msg_total'
              }
            });
            pollingMsgReport = getSessionInfo.batchReportGrafanaTime('channel_polling_msg_final_time');
            pollingMessageAPI = getSessionInfo.pollingMessageV2;
            return [4 /*yield*/, pollingMessageAPI({
              session_id: this.sessionId,
              seq_id: this.sequence || getSessionInfo.getStorage('sequence') || 0
            })];
          case 1:
            res = _j.sent();
            if (res instanceof Error) {
              code = (((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) || {}).code;
              if (code === ErrorCode.SessionExpires) {
                (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug('channel polling msg stop, SessionExpires', {
                  error: res
                });
                // 停止轮询，并关闭长连
                this.stop();
                return [2 /*return*/, res];
              }
              if ((res === null || res === void 0 ? void 0 : res.message) === 'Network Error') {
                //'Network Error' 上报其他错误
                getSessionInfo.batchReportGrafana({
                  type: 'count',
                  value: {
                    label: 'channel_polling_msg_network_error'
                  }
                });
                (_d = this.logger) === null || _d === void 0 ? void 0 : _d.debug('channel polling msg network error', {
                  error: res
                });
                return [2 /*return*/, res];
              }
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'channel_polling_msg_error'
                }
              });
              (_e = this.logger) === null || _e === void 0 ? void 0 : _e.debug('channel polling msg error', {
                error: res
              });
              return [2 /*return*/, res];
            }
            pollingMsgReport();
            _h = res.data || {}, unread_msgs = _h.unread_msgs, session_status = _h.session_status;
            // 当会话状态为end或者miss时，不再拉取消息
            if (session_status === http.SessionStatus.End || session_status === http.SessionStatus.Missed) {
              this.stopPolling();
            }
            messageList = (_g = (_f = unread_msgs || []).map) === null || _g === void 0 ? void 0 : _g.call(_f, function (e) {
              return getSessionInfo.__assign({}, e);
            });
            // 过滤
            messageList.forEach(function (message) {
              getSessionInfo.batchReportGrafana({
                type: 'count',
                value: {
                  label: 'cschat_message_ws_lose_total'
                }
              });
              // 对消息进行处理
              var msg = message;
              if (!message.biz_type) {
                // 如果不存在biz_type,规范化格式
                msg = {
                  biz_type: message.event_type ? 'EVENT' : 'SEND_MSG',
                  biz_content: message,
                  request_id: (message === null || message === void 0 ? void 0 : message.seq_id) || ""
                };
              }
              _this.handleMessage(getSessionInfo.__assign(getSessionInfo.__assign({}, msg), {
                biz_content: JSON.stringify(msg.biz_content)
              }));
            });
            return [2 /*return*/, res];
        }
      });
    });
  };
  /**
   * 判断是否需要消息重发
   *
   * @param {BaseRes<unknown>} res
   * @returns {boolean}
   * @memberof InhouseConnection
   */
  InhouseConnection.prototype.checkRetry = function (res) {
    var response = (res || {}).response;
    var status = (response || {}).status;
    // 5xx 确认重试,或者超时没有status时也重试
    return Number(status) >= 500 || !status;
  };
  InhouseConnection.prototype.getChatInfoWithErrorReport = function () {
    var _a, _b;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var res;
      return getSessionInfo.__generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            // 获取chatInfo消息
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('get chat Info');
            return [4 /*yield*/, getSessionInfo.getChatInfo()];
          case 1:
            res = _c.sent();
            if (res instanceof Error) {
              // 获取chatInfo消息
              (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error('get chat Info error', {
                error: res
              });
            }
            return [2 /*return*/, res];
        }
      });
    });
  };
  InhouseConnection.prototype.handlePageInactive = function () {
    var _this = this;
    var _a;
    this.unSendMessageList.forEach(function (message) {
      _this.emit(message + "resend");
    });
    (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this);
    this.promise = new Promise(function (resolve) {
      _this.resolve = resolve;
    });
  };
  /**
   * 处理消息
   * @param message
   */
  InhouseConnection.prototype.handleMessage = function (message) {
    var _a;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var data, biz_content, requestId, eventName, msg_id, msg_type, seq_id, eventName_1, msg_type, eventName_2, _b, event_type, msg_type, seq_id, eventType_1, content, error;
      var _this = this;
      return getSessionInfo.__generator(this, function (_c) {
        this.stat(message);
        data = message;
        if (data.cmd === 'PONG') {
          return [2 /*return*/];
        }

        biz_content = data.biz_content;
        if (typeof biz_content === 'string') {
          biz_content = jsonParse(data.biz_content);
        }
        requestId = data.request_id || biz_content.seq_id;
        this.sendClientAck(requestId);
        if (data.biz_type.indexOf('ERROR') > -1) {
          this.reportError('server_error');
          // 收到后端错误信息
          this.emitError({
            error: new ConnectionError(biz_content),
            message: 'received error message'
          });
          // 客服没有加入的ERROR且非恢复才算入进线错误
          if (!this.hasCsJoined && !this.isRestore) {
            // 业务进线失败数
            getSessionInfo.batchReportGrafana({
              type: 'count',
              value: {
                label: 'channel_chat_incoming_fail_total'
              }
            });
          }
          // Server 一般错误
          if (data.biz_type === 'COMMON_ERROR') {
            this.stat('COMMON_ERROR');
            return [2 /*return*/];
          }

          if (data.biz_type === 'INHOUSE_GATEWAY_ERROR') {
            this.stat(biz_content);
            return [2 /*return*/];
          }

          if (data.biz_type === 'INHOSUE_CHAT_SERVER_ERROR') {
            this.stat(biz_content);
            return [2 /*return*/];
          }

          this.stat('ERROR');
          return [2 /*return*/];
        }

        eventName = "" + data.biz_type;
        this.emit(eventName, biz_content);
        if (data.biz_type === 'ASK_MSG') {
          msg_id = biz_content.msg_id, msg_type = biz_content.msg_type, seq_id = biz_content.seq_id;
          this.updateSequence(seq_id);
          eventName_1 = [data.biz_type, msg_type, msg_id].join(':');
          this.emit(eventName_1, biz_content);
          if (msg_type === 'IMG') {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('send_message recive_server_ack', {
              eventName: eventName_1
            });
          }
        }
        if (data.biz_type === 'SEND_MSG') {
          msg_type = biz_content.msg_type;
          biz_content.content = jsonParse(biz_content.content);
          if (!this.queuingTimeReport && msg_type === 'QUEUING') {
            // 排队耗时
            this.queuingTimeReport = getSessionInfo.batchReportGrafanaTime('channel_chat_incoming_queueing_time');
          }
          if (typeof this.queuingTimeReport === 'function' && msg_type === 'CS_JOINED') {
            this.queuingTimeReport();
            // 清空queuingTimeReport
            this.queuingTimeReport = undefined;
          }
          this.handleReceiveMessage(biz_content);
          eventName_2 = [data.biz_type, msg_type].join(':');
          this.emit(eventName_2, biz_content);
        }
        // 这里一般是一些全局广播, 如果其他入口发生的消息, agent typing 状态等
        if (data.biz_type === 'EVENT') {
          _b = biz_content, event_type = _b.event_type, msg_type = _b.msg_type, seq_id = _b.seq_id;
          eventType_1 = event_type || msg_type;
          content = jsonParse(biz_content.content);
          // 为所有Event增加去重逻辑
          if (seq_id) {
            if (this.seqIdSet.has(seq_id)) {
              console.warn('Duplicate seq id of: ', seq_id, data);
              return [2 /*return*/];
            }

            this.seqIdSet.add(seq_id);
            this.updateSequence(seq_id);
          }
          if (['SESSION_CLOSED'].includes(eventType_1)) {
            setTimeout(function () {
              _this.emitClose({
                msg: eventType_1,
                data: data
              });
            }, 2000);
            return [2 /*return*/];
          }

          if (['NO_VALID_AGENT'].includes(eventType_1)) {
            error = new ConnectionError({
              code: constants.GetMsgResCode.LIVE_OFFLINE_ERROR_CODE,
              msg: eventType_1,
              data: getSessionInfo.__assign({
                init_message_id: this.initMessageId
              }, content)
            });
            // 无客服状态数
            this.reportError('no_valid_agent');
            this.emitError({
              error: error
            });
          }
          // 其他事件抛出
          this.emit('message', {
            msg_type: eventType_1,
            content: {}
          });
        }
        return [2 /*return*/];
      });
    });
  };

  return InhouseConnection;
}(MessageBroadcastEventEmitter);
var AgentChat = /** @class */function () {
  function AgentChat(_a) {
    var _b = _a === void 0 ? {} : _a,
      _c = _b.grayReleaseConfig,
      grayReleaseConfig = _c === void 0 ? {
        entry_point: http.GRAY_RELEASE_CONFIG_ENTRY_POINT.Other
      } : _c,
      _d = _b.passGateway,
      passGateway = _d === void 0 ? '' : _d,
      channelType = _b.channelType,
      shopeeEnvironment = _b.shopeeEnvironment,
      fetchInjector = _b.fetchInjector,
      wsPathInjector = _b.wsPathInjector;
    if (wsPathInjector) {
      configWsPathInjector(wsPathInjector);
    }
    if (shopeeEnvironment) {
      getHost.configShopeeEnvironment(shopeeEnvironment);
    }
    if (fetchInjector) {
      fetchInjector(getSessionInfo.fetch);
    }
    if (passGateway) {
      getSessionInfo.configPassGateWay(passGateway);
      // arguments.cn/cschat/v1/init_session => chat/v1/init_session
      // fetch.defaults.baseURL = `${location.protocol}//${passGateway}`;
    }

    this.grayReleaseConfig = grayReleaseConfig;
    this.channelType = channelType || this.channelType;
    this.isVipUser = false;
  }
  AgentChat.prototype.getChannelType = function () {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        if (this.channelType) {
          return [2 /*return*/, this.channelType];
        }
        this.channelType = http.ChannelType.inhouse;
        return [2 /*return*/, this.channelType];
      });
    });
  };
  AgentChat.prototype.getEnquiryType = function (_a) {
    _a.sessionId;
    var entryPoint = _a.entryPoint;
    _a.userQueueType;
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      var res, _b, _c, enquiry_type_infos, _d, language_infos;
      return getSessionInfo.__generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            return [4 /*yield*/, getSessionInfo.enquiryTypesList({
              entry_point: entryPoint || constants.DEFAULT_ENTRY_POINT
            })];
          case 1:
            res = _e.sent();
            if (res instanceof Error) {
              console.error(res);
              return [2 /*return*/, res];
            }
            _b = res.data, _c = _b.enquiry_type_infos, enquiry_type_infos = _c === void 0 ? [] : _c, _d = _b.language_infos, language_infos = _d === void 0 ? [] : _d;
            return [2 /*return*/, {
              enquiryTypeInfos: enquiry_type_infos.map(function (enquiry_type_info) {
                var _a;
                return {
                  originItem: enquiry_type_info,
                  value: enquiry_type_info.user_type,
                  content: enquiry_type_info.user_type_content,
                  child: (_a = enquiry_type_info.enquiry_types) === null || _a === void 0 ? void 0 : _a.map(function (enquiry_type) {
                    return {
                      originItem: enquiry_type,
                      value: enquiry_type.id,
                      content: enquiry_type.enquiry_type,
                      isInboundOrder: !!enquiry_type.is_inbound_order,
                      reasonCodeL1Id: enquiry_type.reason_code_l1_id,
                      reasonCodeL1Name: enquiry_type.reason_code_l1_name,
                      child: (enquiry_type.problem_types || []).map(function (problem_type) {
                        return {
                          originItem: problem_type,
                          value: problem_type.id,
                          content: problem_type.problem_type
                        };
                      })
                    };
                  })
                };
              }),
              languageInfos: language_infos.map(function (language_info) {
                return {
                  originItem: language_info,
                  languageCode: language_info.language_code,
                  languageName: language_info.language_name
                };
              }),
              originData: res === null || res === void 0 ? void 0 : res.data
            }];
        }
      });
    });
  };
  AgentChat.prototype.connect = function (enquiryData) {
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        this.connection = new InhouseConnection({});
        getSessionInfo.agentChatScheduler.initMasterAgent(this.connection);
        this.connection.connect(enquiryData);
        return [2 /*return*/, this.connection];
      });
    });
  };
  AgentChat.prototype.restore = function (data, config) {
    var _a;
    if (config === void 0) {
      config = {};
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            (_a = this.connection) === null || _a === void 0 ? void 0 : _a.stop();
            this.connection = new InhouseConnection({});
            getSessionInfo.agentChatScheduler.initMasterAgent(this.connection, true, data.fromWorker);
            return [4 /*yield*/, this.connection.restore({
              sessionId: data.id,
              sequence: data.sequence,
              entryPoint: data.entryPoint
            }, config, data)];
          case 1:
            _b.sent();
            return [2 /*return*/, this.connection];
        }
      });
    });
  };
  AgentChat.prototype.restoreWithDelay = function (data, config) {
    if (config === void 0) {
      config = {};
    }
    return getSessionInfo.__awaiter(this, void 0, void 0, function () {
      return getSessionInfo.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!data.fromWorker) return [3 /*break*/, 2];
            return [4 /*yield*/, getSessionInfo.agentChatScheduler.becomeMasterSuccess()];
          case 1:
            if (!_a.sent()) {
              return [2 /*return*/];
            }

            _a.label = 2;
          case 2:
            return [2 /*return*/, this.restore(data, config)];
        }
      });
    });
  };
  return AgentChat;
}();
var sharedInitedKey = 'SHARED_INITED';
var SharedAgentChat = /** @class */function () {
  function SharedAgentChat() {}
  SharedAgentChat.reset = function () {
    var _a, _b;
    if (getSessionInfo.agentChatScheduler.isMaster) {
      var timer = getSessionInfo.getStorage(getSessionInfo.masterTimerKey);
      timer != null && window.clearInterval(timer);
      getSessionInfo.agentChatScheduler.close();
      var connection = window.__chatbotAgent.connection;
      if (connection) {
        (_a = connection.stop) === null || _a === void 0 ? void 0 : _a.call(connection);
      }
    }
    (_b = getSessionInfo.agentChatScheduler.workerAgent) === null || _b === void 0 ? void 0 : _b.clear();
  };
  Object.defineProperty(SharedAgentChat, "inited", {
    get: function get() {
      return getSessionInfo.getSessionStorage(sharedInitedKey);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SharedAgentChat.prototype, "isMaster", {
    get: function get() {
      return getSessionInfo.agentChatScheduler.isMaster;
    },
    enumerable: false,
    configurable: true
  });
  SharedAgentChat.prototype.init = function (config) {
    getSessionInfo.setSessionStorage(sharedInitedKey, true);
    window.addEventListener('beforeunload', function () {
      getSessionInfo.setSessionStorage(sharedInitedKey, false);
    });
    getSessionInfo.agentChatScheduler.init(config);
    var connection = new WorkerProxyConnection(config.connectionHandlers);
    var exist = this.checkMasterIsExist();
    getSessionInfo.devLog("check master exist", exist);
    if (!exist) {
      return connection;
    }
    initChat(config);
    return connection;
  };
  SharedAgentChat.prototype.checkMasterIsExist = function () {
    return getSessionInfo.checkMasterIsExist();
  };
  SharedAgentChat.prototype.emitRating = function (data) {
    if (getSessionInfo.agentChatScheduler.inited) {
      setRatingStorage(data);
    }
  };
  SharedAgentChat.prototype.emitReadedMessage = function (data) {
    var cacheData = getSessionInfo.getStorage(getSessionInfo.readedMessageCountKey);
    if (cacheData == null) {
      data = getSessionInfo.__assign(getSessionInfo.__assign({}, data), {
        first: true
      });
    }
    setReadedMessageStorage(data);
  };
  return SharedAgentChat;
}();
Object.defineProperty(exports, 'CastType', {
  enumerable: true,
  get: function get() {
    return getSessionInfo.CastType;
  }
});
exports.abortMultipartUpload = getSessionInfo.abortMultipartUpload;
exports.baseURL = getSessionInfo.baseURL;
exports.chatEnd = getSessionInfo.chatEnd;
exports.chatNotTyping = getSessionInfo.chatNotTyping;
exports.chatTyping = getSessionInfo.chatTyping;
exports.completeMultipartUpload = getSessionInfo.completeMultipartUpload;
exports.createMultipartUpload = getSessionInfo.createMultipartUpload;
exports.createNewSession = getSessionInfo.createNewSession;
exports.downloadWithUrl = getSessionInfo.downloadWithUrl;
exports.enquiryTypesList = getSessionInfo.enquiryTypesList;
exports.fetch = getSessionInfo.fetch;
exports.getChatHistory = getSessionInfo.getChatHistory;
exports.getChatInfo = getSessionInfo.getChatInfo;
exports.getDownloadUrl = getSessionInfo.getDownloadUrl;
exports.getLiveChatConfig = getSessionInfo.getLiveChatConfig;
exports.getMessage = getSessionInfo.getMessage;
exports.getQueueList = getSessionInfo.getQueueList;
exports.getSessionInfo = getSessionInfo.getSessionInfo;
exports.getUserSession = getSessionInfo.getUserSession;
exports.grayReleaseConfig = getSessionInfo.grayReleaseConfig;
exports.initChasitor = getSessionInfo.initChasitor;
exports.initChat = getSessionInfo.initChat;
exports.initSession = getSessionInfo.initSession;
exports.pollingMessage = getSessionInfo.pollingMessage;
exports.pollingMessageV2 = getSessionInfo.pollingMessageV2;
exports.postChatHeartbeat = getSessionInfo.postChatHeartbeat;
exports.postImg = getSessionInfo.postImg;
exports.postMessage = getSessionInfo.postMessage;
exports.sendAck = getSessionInfo.sendAck;
exports.sendMsg = getSessionInfo.sendMsg;
exports.sendRating = getSessionInfo.sendRating;
exports.sendStartSession = getSessionInfo.sendStartSession;
exports.sendUserCloseSession = getSessionInfo.sendUserCloseSession;
exports.unreadMessage = getSessionInfo.unreadMessage;
exports.uploadChatbotMessage = getSessionInfo.uploadChatbotMessage;
exports.uploadEnquiryInfo = getSessionInfo.uploadEnquiryInfo;
exports.uploadFile = getSessionInfo.uploadFile;
exports.uploadPart = getSessionInfo.uploadPart;
exports.validateDownload = getSessionInfo.validateDownload;
exports.AgentChat = AgentChat;
exports.ConnectionError = ConnectionError;
exports.InhouseConnection = InhouseConnection;
exports.SharedAgentChat = SharedAgentChat;